<template>
  <div class="comp-container" :class="{ 'comp-container__h5': isH5 }">
    <div class="logo-box" v-if="!isElectron && type !== 'QR'">
      <img src="../../../assets/images/login/logo.png" alt="" />
    </div>
    <!-- 短信登录或者账户密码登录 -->
    <div v-show="type !== 'QR'" class="form-box module">
      <tabs
        class="tabs-box"
        :tabs-data="tabsData"
        @change="changeLoginMethod"
      />
      <div
        class="form-container"
        :class="{ 'form-container__password': type === 'Password' }"
      >
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          auto-complete="on"
          label-position="left"
          @keydown.native.enter.prevent="handleEnterKey"
        >
          <el-form-item prop="mobile">
            <el-input
              v-if="type === 'Password'"
              v-model.trim="loginForm.mobile"
              size="large"
              class="login-mobile-input"
              placeholder="请输入您的账号"
              tabindex="1"
              auto-complete="on"
              inputmode="numeric"
              @input="handleInput"
            />
            <input-phone
              v-else
              :mobile.sync="loginForm.mobile"
              :code.sync="loginForm.region_num"
              :code-list="codeList"
            />
          </el-form-item>
          <el-form-item v-if="type === 'Password'" prop="password">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              class="login-password-input"
              :type="passwordType"
              placeholder="请输入您的密码"
              name="password"
              tabindex="2"
              auto-complete="on"
            >
              <img
                slot="suffix"
                :src="passwordType === 'password' ? hideIcon : showIcon"
                alt=""
                @click="showPwd"
              />
            </el-input>
          </el-form-item>
        </el-form>
        <el-button
          class="btn"
          type="primary"
          :disabled="nextStepDisabled"
          @click="nextStep('bottom')"
        >
          {{ loginText }}
        </el-button>
        <div class="protocol-privacy">
          <p class="protocol-box">
            <el-checkbox v-model="checkAutoLogin" />
            <span class="text"> 30天内自动登录 </span>
          </p>
          <p class="protocol-box">
            <el-checkbox v-model="checkProtocol" />
            <span class="text" :class="{ 'red-text': isRedProtocol }">
              我已阅读并同意
              <el-link
                :underline="false"
                :href="webUrl + '/service-agreement'"
                target="_blank"
                type="primary"
                style="margin: 0 3px"
              >
                服务协议
              </el-link>
              和
              <el-link
                :underline="false"
                :href="'https://cdn.moguocdn.com/cdn/static/privacy-policy.html'"
                target="_blank"
                type="primary"
                style="margin: 0 3px"
              >
                隐私政策
              </el-link>
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- 扫码登录 -->
    <div v-show="type === 'QR'" class="qr-box module">
      <div v-if="!scanSuccess" class="title-container">
        <p class="title">扫码登录</p>
        <p class="tips">请使用微信扫描二维码</p>
      </div>
      <div class="qr-container">
        <div class="box">
          <div class="qr-img">
            <img v-show="qrParams.qrCode" :src="qrParams.qrCode" alt="" />
            <img
              class="logo-img"
              src="https://cdn.moguocdn.com/cdn/static/images/favicon.ico"
              alt=""
            />
          </div>
          <div
            v-if="isExpire && !scanSuccess"
            class="refresh-box"
            @click="refreshQRCode(true)"
          >
            <div class="qr-scan-mask-cover">
              <span
                class="newLogin_scan-refresh"
                :class="{ 'loading-refresh': isLoadingQRCode }"
              >
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  data-icon="RefreshOutlined"
                >
                  <path
                    d="M17.745 8a7 7 0 1 0 .965 6h2.067A9 9 0 1 1 19 6.343V4a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 1 1 0-2h2.745Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              {{ isLoadingQRCode ? "加载中" : "刷新二维码" }}
            </div>
          </div>
        </div>
        <div v-if="!scanSuccess" class="tips">
          <el-checkbox v-model="checkAutoLogin" />
          <span class="text"> 30天内自动登录 </span>
        </div>
      </div>
      <div v-if="scanSuccess" class="success-text">
        <p>扫码成功</p>
        <p>请在微信中确认登录</p>
      </div>
    </div>
    <div class="switch-container_QR" v-if="!isH5">
      <div class="switch" @click="changeLoginType('top')">
        <img v-if="type !== 'QR'" class="img" :src="qrImg" alt="" />
        <img v-else class="img" :src="pcImg" alt="" />
      </div>
    </div>
    <div class="close-btn" v-if="!isElectron" @click="close">
      <img
        class="close-icon"
        v-if="!isH5"
        src="../../../assets/images/login/close.png"
        alt=""
      />
      <img
        class="back-icon"
        v-else
        src="../../../assets/images/login/back.png"
        alt=""
      />
    </div>
    <protocol-confirm-dialog
      :visible.sync="protocolVisible"
      @confirm="onConfirmProtocol"
    ></protocol-confirm-dialog>
  </div>
</template>

<script>
import ManMachineVerify from "@saas/components/src/mixins/manMachineVerify.js";
import Login from "@saas/components/src/mixins/login.js";
import Tabs from "./Tabs.vue";
import InputPhone from "./InputPhone.vue";
import ProtocolConfirmDialog from "./ProtocolConfirmDialog.vue";
import { isH5 } from "@saas/components/src";
const passwordReg = /[^\s]{6,}/;
const mobileReg = /^1[3456789]\d{9}$/;
export default {
  components: {
    Tabs,
    InputPhone,
    ProtocolConfirmDialog,
  },
  props: {
    inputType: {
      type: String,
      default: "Code",
    },
  },
  mixins: [ManMachineVerify, Login],
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!passwordReg.test(value)) {
        callback(new Error("密码至少6位数"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      // 校验手机号
      if (this.type === "Code") {
        if (!value) {
          callback(new Error("请输入您的手机号"));
        } else if (value.length > 11 || value.length < 6) {
          callback(new Error("请输入正确的手机号"));
        } else if (
          this.loginForm.region_num === "86" &&
          !/^[1]([3-9])\d{9}$/.test(value)
        ) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else {
        if (!value) {
          callback(new Error("请输入您的账号"));
        } else {
          callback();
        }
      }
    };
    return {
      webUrl: process.env.VUE_APP_SAAS_WEB_URL,
      tabsData: [
        {
          title: "手机号",
          isActive: true,
          type: "Code",
        },
        {
          title: "账号密码",
          isActive: false,
          type: "Password",
        },
      ],
      qrImg: require("../../../assets/images/login/qr.png"),
      pcImg: require("../../../assets/images/login/pc.png"),
      showIcon: require("../../../assets/images/login/show.png"),
      hideIcon: require("../../../assets/images/login/hide.png"),
      loginForm: {
        mobile: "",
        password: "",
      },
      loginRules: {
        mobile: [{ trigger: "blur", validator: validateMobile }],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      loading: false,
      passwordType: "password",
      redirect: null,
      //   returnUrl: null,
      // 登录界面类型： QR 二维码 Password 密码 Code 验证码,
      // 用于判断界面显示
      type: "Code",
      // 验证码类型
      verifyCodeType: "login",
      // 切换二维码之前的登录界面类型
      qrBeforeType: "Code",
      // 是否选中阅读协议
      checkProtocol: false,
      // 是否选中30天自动登录
      checkAutoLogin: true,
      // 扫码成功
      scanSuccess: false,
      // 二维码是否过期
      isExpire: true,
      // 二维码是否加载中
      isLoadingQRCode: false,
      // 我已阅读xxx 文字变红
      isRedProtocol: false,
      loginType: "",
      qrImgUrl: "",
      qrParams: {
        qrCode: "",
        sceneStr: "",
      },
      checkStatusTimer: null,
      isElectron: window.isElectron,
      isH5: isH5(),
      protocolVisible: false,
      actionType: 1, // 1: 登录 2: 切换登录方式
    };
  },
  computed: {
    footerText() {
      switch (this.type) {
        case "Password":
          return "短信登录";
        case "Code":
          return "账号密码登录";
        default:
          return "账号密码登录";
      }
    },
    loginText() {
      switch (this.type) {
        case "Password":
          return "登录";
        case "Code":
          return "发送验证码";
        default:
          return "登录";
      }
    },
    nextStepDisabled() {
      if (this.type === "Password") {
        return (
          !passwordReg.test(this.loginForm.password) || !this.loginForm.mobile
        );
      } else {
        return (
          this.loginForm.mobile.length > 11 ||
          this.loginForm.mobile.length < 6 ||
          (this.loginForm.region_num === "86" &&
            !/^[1]([3-9])\d{9}$/.test(this.loginForm.mobile))
        );
      }
    },
    codeList() {
      return this.$store.state.user.areaCodeList || [];
    },
  },
  watch: {
    loginForm: {
      handler(val) {
        this.$store.commit("user/SET_LOGIN_FORM", val);
      },
      deep: true,
    },
    checkAutoLogin: {
      handler(val) {
        this.$store.commit("user/SET_AUTO_LOGIN", val);
      },
      immediate: true,
    },
    codeList: {
      handler(val) {
        this.setSelectRegionNum();
      },
      deep: true,
    },
    type: {
      handler(val) {
        if (val === "Code") {
          this.tabsData = [
            {
              title: "手机号",
              isActive: true,
              type: "Code",
            },
            {
              title: "账号密码",
              isActive: false,
              type: "Password",
            },
          ];
        } else if (val === "Password") {
          this.tabsData = [
            {
              title: "手机号",
              isActive: false,
              type: "Code",
            },
            {
              title: "账号密码",
              isActive: true,
              type: "Password",
            },
          ];
        }
      },
      immediate: true,
    },
    inputType: {
      handler(val) {
        this.type = val;
      },
      immediate: true,
    },
  },
  mounted() {
    const { mobile, password, region_num } = this.$store.state.user.loginForm;
    this.loginForm = { mobile, password, region_num };
    this.setSelectRegionNum();
    this.redirect = this.$route.query.redirect || "/";
    // this.returnUrl = this.$route.query.return_url || ''
  },
  beforeDestroy() {
    clearInterval(this.checkStatusTimer);
  },
  methods: {
    handleInput(val) {
      // 首先过滤掉非数字的字符，包括e
      val = val.replace(/[^0-9]/g, "");
      this.loginForm.mobile = val;
    },
    handleKeydown(e) {
      let key = e.key;
      const keys = [".", "-", "+", "e", "E"];
      if (keys.includes(key)) {
        e.returnValue = false;
        return false;
      } else {
        return true;
      }
    },
    // 设置选中区号
    setSelectRegionNum() {
      if (!this.loginForm.region_num) {
        // 没有值，设置默认值
        let regionNum = localStorage.getItem("regionNum") || "";
        if (regionNum) {
          // 如果localStroage里面有值，则赋值
          this.loginForm.region_num = regionNum;
        } else {
          // 如果localStroage里面没有值，则根据ip地址获取区号
          if (this.codeList.length) {
            this.codeList.forEach((item) => {
              if (item.is_def === 1) {
                regionNum = item.region_num;
                this.loginForm.region_num = regionNum;
              }
            });
          }
        }
      }
      this.$nextTick(() => {
        this.$refs.loginForm.clearValidate();
      });
    },
    handleEnterKey(event) {
      if (event.keyCode === 13) {
        if (
          this.type === "Password" &&
          this.loginForm.mobile &&
          this.loginForm.password
        ) {
          this.nextStep();
        }
      }
    },
    // 人机验证回调
    captchaCallback(res) {
      try {
        if (res.ret === 0) {
          this.sendVerifyCode(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 发送验证码
    sendVerifyCode(res) {
      this.$store
        .dispatch("user/sendCode", {
          account: this.loginForm.mobile,
          region_num: this.loginForm.region_num
            ? this.loginForm.region_num + ""
            : "",
          randstr: res.randstr,
          scene: "QuickLogin",
          ticket: res.ticket,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$emit("sendCodeSuccess", this.verifyCodeType);
          }
        })
        .catch(() => {
          this.$message.error("验证码发送失败，请稍后重试");
        });
    },
    // 点击下一步， 登录或者发送验证码
    nextStep() {
      if (this.checkProtocol) {
        if (this.type === "Password") {
          this.$store.commit("user/SET_LOGIN_FORM", {
            sceneStr: "",
          });
          // 密码登录
          this.$refs.loginForm.validate((valid) => {
            if (valid) {
              this.$store
                .dispatch("user/login", {
                  account: this.loginForm.mobile,
                  password: this.loginForm.password,
                })
                .then(({ code, message, data }) => {
                  if (code === 1) {
                    this.checkIdentity().then((isIdentity) => {
                      if (isIdentity) {
                        this.loginSuccess();
                        this.$message.success("登录成功");
                      } else {
                        this.$emit("goSelectIdentity");
                      }
                    });
                  } else if (code === 20000) {
                    // 用户不存在，发送验证码用于注册
                    this.$message.error("用户未注册，可通过手机号登录进行注册");
                    this.verifyCodeType = "register";
                  } else {
                    this.$message.error(message);
                  }
                })
                .catch(() => {});
            }
          });
        } else {
          // 发送验证码前需要人机验证
          this.captcha.show();
        }
      } else {
        // 未勾选协议
        // this.isRedProtocol = true;
        this.actionType = 1;
        this.protocolVisible = true;

        // this.$message.error("请先阅读并同意服务协议和隐私政策");
      }
    },
    // 切换登录方式
    changeLoginType(type) {
      // if (type === "bottom") {
      //   // 账号密码登录和短信登录切换
      //   this.type = this.type === "Password" ? "Code" : "Password";
      // } else {
      // 二维码和其他方法切换
      if (this.type === "QR") {
        clearInterval(this.checkStatusTimer);
        this.type = this.qrBeforeType || "Code";
        this.$store.commit("user/SET_LOGIN_FORM", {
          sceneStr: "",
        });
      } else {
        if (this.checkProtocol) {
          this.qrBeforeType = this.type;
          this.type = "QR";
          this.refreshQRCode(true);
        } else {
          this.actionType = 2;
          this.protocolVisible = true;
          // this.$message.error("请先阅读并同意服务协议和隐私政策");
        }
      }
      // }
    },
    // 扫码成功后
    handleScanSuccess() {},
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    // 定时检查微信扫码状态
    checkWxStatus() {
      clearInterval(this.checkStatusTimer);
      this.checkStatusTimer = setInterval(() => {
        this.$store
          .dispatch("user/checkStatus", {
            scene_str: this.qrParams.sceneStr,
          })
          .then((res) => {
            if (res.code === 1) {
              clearInterval(this.checkStatusTimer);
              this.checkIdentity().then((isIdentity) => {
                if (isIdentity) {
                  this.loginSuccess();
                  this.$message.success("登录成功");
                } else {
                  this.$emit("goSelectIdentity");
                }
              });
            } else if (res.code === 20000) {
              // 用户不存在
              clearInterval(this.checkStatusTimer);
              // this.$message.error(res.message);
              this.type = "Code";
              this.verifyCodeType = "register";
              this.$emit("goBindAccount");
            } else if (res.code === 10037) {
              // 过期
              clearInterval(this.checkStatusTimer);
              this.$message.error(res.message);
              this.isExpire = true;
              // this.refreshQRCode(false)
            } else if (res.code === 10038) {
              // 等待扫码中
            } else {
              this.$message.error(res.message);
              clearInterval(this.checkStatusTimer);
              this.isExpire = true;
            }
          });
      }, 3000);
    },
    // 刷新二维码
    refreshQRCode(isCheckStatus) {
      this.isLoadingQRCode = true;
      this.$store.dispatch("user/wechatLogin").then((res) => {
        if (res.code === 1) {
          this.qrParams = {
            qrCode: res.data.qr_code,
            sceneStr: res.data.scene_str,
          };
          this.$store.commit("user/SET_LOGIN_FORM", {
            sceneStr: res.data.scene_str,
          });
          if (isCheckStatus) {
            this.checkWxStatus();
          }
        }
        this.isExpire = false;
        this.isLoadingQRCode = false;
      });
    },
    changeLoginMethod(val) {
      this.type = val?.type || "Code";
      this.$refs.loginForm?.clearValidate();
    },
    close() {
      this.$currentLoginDialog.close();
    },
    onConfirmProtocol() {
      this.checkProtocol = true;
      if (this.actionType === 1) {
        this.nextStep();
      } else {
        this.changeLoginType();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 480px;
  height: 550px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(156, 175, 154, 0.17);
  border-radius: 24px;
  padding: 0 48px;
  .module {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    background-color: #fff;
    flex-direction: column;
  }

  .form-box {
    .tabs-box {
      margin-top: 42px;
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: row;
      align-items: center;
    }

    .form-container {
      flex: 1;
      padding: 49px 0 0 0;
      .login-form ::v-deep {
        margin-bottom: 50px;
        .el-form-item {
          margin-bottom: 24px;
          &.is-error {
            .el-input__inner {
              border-color: #f03349;
            }
          }
        }
        .el-input__inner {
          height: 50px;
          border-radius: 16px;
          padding-left: 24px;
          &:focus {
            border-color: #00c89d;
          }
        }
        .el-form-item__error {
          padding-top: 6px;
          font-weight: 400;
          font-size: 12px;
          color: #f03349;
        }
        .login-password-input {
          .el-input__suffix {
            display: flex;
            align-items: center;
            right: 16px;
            cursor: pointer;
          }
          img {
            width: 16px;
            height: 16px;
          }
        }
      }

      .btn {
        width: 100%;
        height: 50px;
        border-radius: 16px !important;
        border: none;
        color: #fff !important;
        font-size: 16px;
        font-weight: 600;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        );
        &:hover {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 1) 0%,
            rgba(0, 200, 157, 1) 100%
          ) !important;
        }
        &:focus {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 1) 0%,
            rgba(0, 200, 157, 1) 100%
          ) !important;
        }
        &.is-disabled {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          );
          &:hover {
            color: #fff !important;
            background: linear-gradient(
              132deg,
              rgba(0, 235, 129, 0.5) 0%,
              rgba(0, 200, 157, 0.5) 100%
            ) !important;
          }
          &:focus {
            color: #fff !important;
            background: linear-gradient(
              132deg,
              rgba(0, 235, 129, 0.5) 0%,
              rgba(0, 200, 157, 0.5) 100%
            ) !important;
          }
        }
      }

      .protocol-privacy {
        margin-top: 20px;
        .protocol-box {
          display: flex;
          flex-direction: row;
          align-items: center;
          &:first-child {
            margin-bottom: 6px;
          }
        }
        .text {
          color: #515350;
          font-size: 14px;
          line-height: 20px;
          // margin-left: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .el-link {
            color: rgba(0, 200, 157, 1);
          }
        }
        .red-text {
          color: #f03349 !important;
          .el-link--inner {
            color: #f03349 !important;
          }
        }
        .el-checkbox ::v-deep {
          .el-checkbox__inner {
            border-radius: 3px;
          }
          .el-checkbox__inner:hover {
            border-color: rgba(0, 200, 157, 1);
          }
          .el-checkbox__input.is-focus .el-checkbox__inner {
            border-color: #e8e8e9;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            border-color: rgba(0, 200, 157, 1);
            background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
            border: none;
            box-sizing: border-box;
            &::after {
              left: 50%;
              top: 50%;
              transform: translate(-50%, -58%) rotate(45deg) scaleY(1);
            }
          }
        }
      }
    }
    .form-container__password {
      padding-top: 29px;
    }

    // .footer-container {
    //   padding: 0 40px 40px 40px;
    //   text-align: center;

    //   .footer-title {
    //     text-align: center;
    //     display: flex;
    //     margin-bottom: 24px;
    //     margin-top: 24px;
    //     width: 100%;
    //     color: #8f959e;

    //     &::before {
    //       position: relative;
    //       top: 50%;
    //       width: 50%;
    //       border-top: 1px solid rgba(31, 35, 41, 0.15);
    //       transform: translateY(50%);
    //       box-sizing: border-box;
    //       content: "";
    //     }

    //     &::after {
    //       position: relative;
    //       top: 50%;
    //       width: 50%;
    //       border-top: 1px solid rgba(31, 35, 41, 0.15);
    //       transform: translateY(50%);
    //       box-sizing: border-box;
    //       content: "";
    //     }

    //     span {
    //       position: relative;
    //       margin: 0;
    //       padding: 0 14px;
    //       font-size: 14px;
    //       line-height: 22px;
    //       color: #8f959e;
    //       display: inline-block;
    //       box-sizing: border-box;
    //       width: 120px;
    //     }
    //   }
    // }
  }

  .qr-box {
    display: flex;
    flex-direction: column;
    text-align: center;
    .title-container {
      padding-top: 80px;
      .title {
        margin: 0;
        font-weight: 500;
        font-size: 24px;
        color: $saas-text-color;
        line-height: 33px;
        white-space: pre-wrap;
      }

      .tips {
        margin: 0;
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        margin-top: 12px;
        line-height: 22px;
        white-space: pre-wrap;
      }
    }

    .qr-container {
      padding: 24px 0 20px 0;
      position: relative;
      .box {
        position: relative;
        width: 220px;
        height: 220px;
        margin: 0 auto;
        border-radius: 10px;
        .qr-img {
          width: 100%;
          height: 100%;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .logo-img {
            position: absolute;
            width: 50px;
            height: 50px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .refresh-box {
          position: absolute;
          cursor: pointer;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;

          &::before {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            display: block;
            content: "";
            background-color: #000;
            border-radius: 10px;
            opacity: 0.6;
          }

          .qr-scan-mask-cover {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 14px;
            color: #fff;
            z-index: 1000;

            .newLogin_scan-refresh {
              display: inline-block;
              font-style: normal;
              line-height: 0;
              text-align: center;
              text-transform: none;
              text-rendering: optimizeLegibility;
              -webkit-font-smoothing: antialiased;
              margin-bottom: 12px;
              font-size: 46px;
            }
            .loading-refresh {
              animation: identifier 1s linear infinite;
            }
          }
        }
      }
      .success-box {
        &::before {
          content: "";
        }
      }
      .tips {
        margin-top: 20px;
        .text {
          color: #646a73;
          font-size: 14px;
        }
      }
    }
    .success-text {
      font-size: 24px;
      color: #1f2329;
      p {
        margin: 0;
        padding: 0;
        &:first-child {
          font-weight: 700;
          line-height: 32px;
        }
        &:last-child {
          margin-top: 12px;
          font-size: 14px;
        }
      }
    }
  }

  .switch-container_QR {
    position: absolute;
    right: 8px;
    top: 8px;
    width: 68px;
    height: 68px;
    overflow: hidden;
    .img {
      width: 68px;
      height: 68px;
    }
    .switch {
      cursor: pointer;
    }

    .bg {
      position: absolute;
      width: 100px;
      height: 100px;
      right: -50px;
      top: -50px;
      transform: rotate(135deg);
      cursor: pointer;
      background-color: #82a7fc;
      transition: background-color 0.3s;
      overflow: hidden;
    }

    .qr-icon {
      position: absolute;
      font-size: 40px;
      color: #fff;
      top: 8px;
      right: 8px;
      // transform: rotate(-45deg);
    }
  }
  .close-btn {
    position: absolute;
    top: 19px;
    left: 19px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .logo-box {
    width: 76px;
    height: 62px;
    margin-top: 36px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.comp-container__h5 {
  width: 100%;
  height: 100%;
  box-shadow: none;
  border-radius: 0;
  padding: 0 0.6667rem;
  .form-box {
    .tabs-box {
      margin-top: 1.3067rem;
    }
    .form-container {
      flex: 1;
      padding: 1.4133rem 0 0 0;
      .login-form ::v-deep {
        margin-bottom: 0.6667rem;
        .el-form-item {
          margin-bottom: 0.6667rem;
        }
        .el-input__inner {
          height: 1.3333rem;
          border-radius: 0.32rem;
          padding-left: 0.4rem;
        }
        .el-form-item__error {
          height: 0.4rem;
          line-height: 0.4rem;
          padding-top: 0.1333rem;
          font-size: 0.2933rem;
        }
        .login-password-input {
          .el-input__suffix {
            right: 0.2667rem;
          }
          img {
            width: 0.4267rem;
            height: 0.4267rem;
          }
        }
      }

      .btn {
        width: 100%;
        height: 1.3333rem;
        border-radius: 0.32rem !important;
        margin-top: 0.5333rem;
        font-size: 0.4267rem;
      }

      .protocol-privacy {
        margin-top: 0.4rem;
        .text {
          font-size: 0.3733rem;
          line-height: 0.5333rem;
        }
        .el-link {
          font-size: 0.3733rem;
        }
        .el-checkbox ::v-deep {
          .el-checkbox__inner {
            border-radius: 0.08rem;
            width: 0.3733rem;
            height: 0.3733rem;
            &::after {
              width: 0.08rem;
              height: 0.1867rem;
            }
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            border-color: rgba(0, 200, 157, 1);
            background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
            border: none;
            box-sizing: border-box;
            &::after {
              left: 50%;
              top: 50%;
              transform: translate(-50%, -58%) rotate(45deg) scaleY(1);
            }
          }
        }
      }
    }

    // .footer-container {
    //   padding: 0 40px 40px 40px;
    //   text-align: center;

    //   .footer-title {
    //     text-align: center;
    //     display: flex;
    //     margin-bottom: 24px;
    //     margin-top: 24px;
    //     width: 100%;
    //     color: #8f959e;

    //     &::before {
    //       position: relative;
    //       top: 50%;
    //       width: 50%;
    //       border-top: 1px solid rgba(31, 35, 41, 0.15);
    //       transform: translateY(50%);
    //       box-sizing: border-box;
    //       content: "";
    //     }

    //     &::after {
    //       position: relative;
    //       top: 50%;
    //       width: 50%;
    //       border-top: 1px solid rgba(31, 35, 41, 0.15);
    //       transform: translateY(50%);
    //       box-sizing: border-box;
    //       content: "";
    //     }

    //     span {
    //       position: relative;
    //       margin: 0;
    //       padding: 0 14px;
    //       font-size: 14px;
    //       line-height: 22px;
    //       color: #8f959e;
    //       display: inline-block;
    //       box-sizing: border-box;
    //       width: 120px;
    //     }
    //   }
    // }
  }
  .close-btn {
    position: absolute;
    top: 0.4rem;
    left: 0.4rem;
    width: 0.4rem;
    height: 0.4rem;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .logo-box {
    width: 2.0267rem;
    height: 1.6533rem;
    margin-top: 0.96rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
@keyframes identifier {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style lang="scss">
.login-mobile-input {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>
